import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";
import Login from "@/views/Login.vue";
import UserProfile from "@/views/UserProfile";
import Organization from "@/views/Organization";
// import Onboarding from "@/views/Onboarding";
import OnboardingV2 from "@/views/OnboardingV2";
import Admin from "@/views/Admin";
import OrganizationPlan from "@/views/OrganizationPlan";
import OrganizationTeam from "@/views/OrganizationTeam";
import OrganizationGetSetup from "@/views/OrganizationGetSetup";
import InternalPayment from "@/components/payment/InternalPayment";
import classesRoutes from "./classes";
import studySetRoutes from "./studysets";
import teachersRoutes from "./teachers";
import organizationsRoutes from "./organizations";
import assignmentsRoutes from "./assignments";
import dashboardRoutes from "./dashboards";
import studentsRoutes from "./students";
import homeWorksRoutes from "./homeworks";
import readAloudRoutes from "./readAlouds";
import CommingSoon from "@/views/CommingSoon";
import { curry, isEmpty, pathOr } from "ramda";
import Prohibited from "@/views/Prohibited.vue";
import AccessNoticePage from "@/views/AccessNoticePage.vue";
const originalPush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(error => {
    if (error && error.name !== "NavigationDuplicated") {
      throw error;
    }
  });
};

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    name: "Login",
    component: Login,
    beforeEnter: async (to, from, next) => {
      await store.dispatch("auth/logout");
      next();
    },
    meta: {
      menuItemIndex: "1",
      title: "Login",
    },
  },
  {
    path: "/profile",
    name: "user-profile",
    component: UserProfile,
    meta: {
      menuItemIndex: "1",
      title: "User Profile",
    },
  },
  {
    path: "/admin",
    name: "admin",
    component: Admin,
    meta: {
      menuItemIndex: "1",
      title: "Admin",
    },
  },
  {
    path: "/admin/organization/:organizationId",
    component: Organization,
    name: "account",
    props: { fromAdmin: true },
    beforeEnter: async (to, from, next) => {
      if (isEmpty(store.state.admin.currentOrganization)) {
        try {
          await store.dispatch("admin/getOrganizationDetail", to.params.organizationId);
          return next();
        } catch (error) {
          return next({
            path: "/admin",
            replace: true,
          });
        }
      }
      next();
    },
    meta: {
      menuItemIndex: "2",
      title: "Organization Profile",
    },
  },
  {
    path: "/admin/organization/:organizationId/plan",
    component: OrganizationPlan,
    name: "OrganizationPlan",
    meta: {
      menuItemIndex: "6",
      title: "Plan & Payment",
    },
    // TODO: allow only default admin
  },
  {
    path: "/admin/organization/:organizationId/team",
    component: OrganizationTeam,
    name: "organizationteam",
    props: true,
    meta: {
      menuItemIndex: "3",
      title: "Team",
    },
    // TODO: allow only default admin
  },
  {
    path: "/admin/organization/:organizationId/onboarding",
    component: OrganizationGetSetup,
    name: "organization_setup",
    meta: {
      menuItemIndex: "1",
      title: "Get Set Up",
    },
    // TODO: allow only default admin
  },
  {
    path: "/onboarding",
    name: "onboarding",
    component: OnboardingV2,
    meta: {
      menuItemIndex: "1",
      title: "On Boarding",
    },
  },
  {
    path: "/admin/organization/:organizationId/internal-payment",
    component: InternalPayment,
    name: "InternalPayment",
    meta: {
      menuItemIndex: "11",
      title: "Internal payment",
    },
  },
  {
    path: "/comming-soon",
    name: "comming-soon",
    component: CommingSoon,
    meta: {
      title: "Comming Soon",
    },
  },
  {
    path: "/prohibited",
    name: "prohibited",
    component: Prohibited,
  },
  {
    path: "/access-notice",
    name: "access-notice",
    component: AccessNoticePage,
  },
  ...organizationsRoutes,
  ...dashboardRoutes,
  ...classesRoutes,
  ...studySetRoutes,
  ...teachersRoutes,
  ...studentsRoutes,
  ...assignmentsRoutes,
  ...homeWorksRoutes,
  ...readAloudRoutes,
];

const router = new VueRouter({
  mode: "history",
  routes,
});

const addInviteNotification = curry((store, organizationName, success) => {
  return store.dispatch("invite/addInviteNotification", {
    organizationName,
    success,
  });
});
const handleInvite = async (to, store, next) => {
  const inviteParams = pathOr({}, ["query", "invite"])(to);
  if (isEmpty(inviteParams)) {
    return next({ name: "dashboard" });
  }

  const inviteBuffer = new Buffer(inviteParams, "base64");
  const invite = JSON.parse(inviteBuffer.toString());
  const { token, organization_name: organizationName, email } = invite;

  const addNewInviteNotification = addInviteNotification(store, organizationName);
  if (email !== store.state.user.userInfo.email) {
    addNewInviteNotification(false);
  } else {
    try {
      await store.dispatch("invite/acceptInvite", { token });
      addNewInviteNotification(true);
    } catch (error) {
      addNewInviteNotification(false);
    }
  }
  return next({ name: "dashboard" });
}
// Guard to move unauthenticated calls to /login
router.beforeEach(async (to, from, next) => {
  const isLoggedIn = store.state.auth.isLoggedIn;
  if (!isLoggedIn) {
    const loggedIn = await store.dispatch("auth/restoreAuthData");

    if (loggedIn) {
      if (to.name === "Login" || to.name === "Signup") {
        handleInvite(to, store, next);
      }
      return next();
    }
  }
  if (!isLoggedIn && to.name !== "Login" && to.name !== "Signup") {
    const intendedPath = to.fullPath;
    return next({
      path: "/login",
      replace: true,
      query: {redirect: intendedPath},
    });
  }

  return next();
});

export default router;
